import {
    FETCH_NOTIFICATIONS_REQUEST,
    FETCH_NOTIFICATIONS_SUCCESS,
    FETCH_NOTIFICATIONS_FAILURE,
    MARK_NOTIFICATION_AS_READ,
    MARK_ALL_NOTIFICATIONS_AS_READ,
    SET_NOTIFICATIONS_SUMMARY,
    UPDATE_NOTIFICATION_COUNTS,
    CLEAR_NOTIFICATIONS
} from './types';

const initialState = {
    notifications: [],
    loading: false,
    error: null,

    // Conteggi per le diverse sezioni
    frameValidationCount: 0,
    ordersCount: 0,
    totalUnread: 0,

    // Riassunto raggruppato per tipo
    notificationsSummary: {
        grouped: {},
        totalUnread: 0
    }
};

const notificationsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_NOTIFICATIONS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_NOTIFICATIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                notifications: action.payload,
                error: null
            };

        case FETCH_NOTIFICATIONS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case MARK_NOTIFICATION_AS_READ:
            const updatedNotifications = state.notifications.map(notification =>
                notification.id === action.payload
                    ? { ...notification, read: true }
                    : notification
            );

            // Ricalcola i conteggi dopo aver marcato la notifica come letta
            const unreadNotifications = updatedNotifications.filter(notification => !notification.read);
            let frameValidationCount = 0;
            let ordersCount = 0;
            let totalUnread = unreadNotifications.length;

            unreadNotifications.forEach(notification => {
                const type = notification.type || "";
                if (type.includes("Variant")) {
                    frameValidationCount++;
                } else if (type.includes("Order")) {
                    ordersCount++;
                }
            });

            // Ricalcola il riassunto per tipo
            const grouped = {};
            updatedNotifications.forEach(notification => {
                const type = notification.type || "Unknown";
                if (!grouped[type]) {
                    grouped[type] = { total: 0, unread: 0 };
                }
                grouped[type].total++;
                if (!notification.read) {
                    grouped[type].unread++;
                }
            });

            return {
                ...state,
                notifications: updatedNotifications,
                frameValidationCount,
                ordersCount,
                totalUnread,
                notificationsSummary: {
                    grouped,
                    totalUnread
                }
            };

        case MARK_ALL_NOTIFICATIONS_AS_READ:
            return {
                ...state,
                notifications: state.notifications.map(notification => ({
                    ...notification,
                    read: true
                })),
                frameValidationCount: 0,
                ordersCount: 0,
                totalUnread: 0,
                notificationsSummary: {
                    grouped: Object.keys(state.notificationsSummary.grouped).reduce((acc, key) => {
                        acc[key] = {
                            ...state.notificationsSummary.grouped[key],
                            unread: 0
                        };
                        return acc;
                    }, {}),
                    totalUnread: 0
                }
            };

        case UPDATE_NOTIFICATION_COUNTS:
            return {
                ...state,
                frameValidationCount: action.payload.frameValidationCount,
                ordersCount: action.payload.ordersCount,
                totalUnread: action.payload.totalUnread
            };

        case SET_NOTIFICATIONS_SUMMARY:
            return {
                ...state,
                notificationsSummary: action.payload
            };

        case CLEAR_NOTIFICATIONS:
            return {
                ...initialState
            };

        default:
            return state;
    }
};

export default notificationsReducer; 